






















import {Vue, Component, Prop} from "vue-property-decorator";
import {ProgressIconsListType} from "@/types/surveyComponent.type";

@Component
export default class StepperTooltip extends Vue {
    @Prop() private icons!: ProgressIconsListType;
}
